import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: "AIzaSyCuj8cbGnzIZYqmhyVKiDImpcYaYt4YASU",
  authDomain: "devchatapp-b3bab.firebaseapp.com",
  projectId: "devchatapp-b3bab",
  storageBucket: "devchatapp-b3bab.appspot.com",
  messagingSenderId: "577823128699",
  appId: "1:577823128699:web:23cdac4e6c39770f3cf6de"
};
export const app = initializeApp(firebaseConfig);